export const contactInfo = {
  brand: "Lahari Packers and Movers",
  tagline: "#1 Shifting Services in Bangalore | Since 2009",
  phone: "+91-99863 03349",
  phoneHref: "tel:+919986303349",
  phoneAlt: "+91-97427 65681",
  phoneAltHref: "tel:+919742765681",
  whatsappHref: "https://wa.me/919986303349",
  email: "laharipackersandmovers109@gmail.com",
  emailHref: "mailto:laharipackersandmovers109@gmail.com",
  address:
    "Anikethana Nagara, Kannahalli, Bengaluru, Karnataka 560112.",
  hoursWeek: "Mon to Sat: 9:30 AM – 6:30 PM",
  hoursSun: "Sunday: 10:30 AM – 2:30 PM",
  support: "24 x 7 Customer Support",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5861.460801093229!2d77.44442434910671!3d12.982166422556176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3bdc3de7f553%3A0xbfab33dde57a61!2sLAHARI%20PAKERS%20%26%20MOVERS!5e1!3m2!1sen!2sin!4v1791104178967!5m2!1sen!2sin",
  mapLink: "https://www.google.com/maps/dir/?api=1&destination=12.982166422556176,77.44442434910671",
  logo:
    "https://static.readdy.ai/image/d59ba4ba4e5f160e4781d8b81f851394/0b3b31cd6a81a00dadd32efb0f200320.png",
};

export const socialLinks = [
  { label: "Facebook", icon: "ri-facebook-fill", href: "https://www.facebook.com/Lahari-packers-and-movers-1868691160036626/" },
  { label: "Google", icon: "ri-google-fill", href: "https://maps.app.goo.gl/Fbcy2wkkirJXD3eN8" },
];

export const navItems = [
  { label: "Home", href: "/" },
  { label: "About us", href: "/about" },
  {
    label: "Services",
    href: "/services",
    children: [
      { label: "House Shifting Services in Bangalore", href: "/services/house-shifting" },
      { label: "Office Shifting Services in Bangalore", href: "/services/office-shifting" },
      { label: "Storage service in Bangalore", href: "/services/storage" },
      { label: "Local Shifting Services in Bangalore", href: "/services/local-shifting" },
    ],
  },
  { label: "Areas we Serve", href: "/areas-we-serve" },
  { label: "Warehouse Facility", href: "/warehouse" },
  { label: "Highlights", href: "/highlights" },
  { label: "Gallery", href: "/gallery" },
  { label: "Contact us", href: "/contact" },
];

export const popularSearches = [
  { label: "Best Packers and Movers in Bangalore", href: "/services" },
  { label: "Top Packers and Movers in Nagarabhavi", href: "/areas-we-serve/nagarabhavi" },
  { label: "Packers and Movers Rajajinagar Bangalore", href: "/areas-we-serve/rajajinagar" },
  { label: "Local Packers and Movers in Malleswaram", href: "/areas-we-serve/malleswaram" },
  { label: "Packers and Movers Vijayanagar Bangalore", href: "/areas-we-serve/vijayanagar" },
  { label: "Local Shifting in Basaveshwaranagar", href: "/areas-we-serve/basaveshwaranagar" },
  { label: "Packers and Movers Jayanagar", href: "/areas-we-serve/jayanagar" },
  { label: "Packers and Movers JP Nagar Bangalore", href: "/areas-we-serve/jp-nagar" },
  { label: "Local Shifting in Banashankari Bangalore", href: "/areas-we-serve/banashankari" },
  { label: "Packers and Movers HSR Layout", href: "/areas-we-serve/hsr-layout" },
  { label: "Packers and Movers Koramangala", href: "/areas-we-serve/koramangala" },
  { label: "Packers and Movers Whitefield", href: "/areas-we-serve/whitefield" },
  { label: "Packers and Movers Marathahalli", href: "/areas-we-serve/marathahalli" },
  { label: "Packers and Movers Mysore Road", href: "/areas-we-serve/kengeri" },
  { label: "Packers and Movers in Anikethana Nagara", href: "/areas-we-serve/anikethana-nagara" },
  { label: "Packers and Movers Kannahalli Bangalore", href: "/areas-we-serve/kannahalli" },
  { label: "Packers and Movers Magadi Road Bangalore", href: "/areas-we-serve/magadi-road" },
  { label: "Local Shifting near NICE Road", href: "/areas-we-serve/nice-road" },
  { label: "Packers and Movers Seegehalli", href: "/areas-we-serve/seegehalli" },
  { label: "Packers and Movers Giddenahalli", href: "/areas-we-serve/giddenahalli" },
  { label: "Packers and Movers RR Nagar", href: "/areas-we-serve/rr-nagar" },
  { label: "Packers and Movers Yelahanka", href: "/areas-we-serve/yelahanka" },
  { label: "Lahari Packers and Movers, Gnanabharathi", href: "/areas-we-serve/nagarabhavi" },
  { label: "Packers and Movers near me", href: "/contact" },
];

export const footerServices = [
  { label: "House Shifting Services", href: "/services/house-shifting" },
  { label: "Office Shifting Services", href: "/services/office-shifting" },
  { label: "Storage Service", href: "/services/storage" },
  { label: "Local Shifting Service", href: "/services/local-shifting" },
  { label: "Warehouse Facility", href: "/warehouse" },
];

export const footerMenuLinks = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Areas We Serve", href: "/areas-we-serve" },
  { label: "Warehouse Facility", href: "/warehouse" },
  { label: "Highlights", href: "/highlights" },
  { label: "Image Gallery", href: "/gallery" },
  { label: "Get A Quote", href: "/request-a-quote" },
  { label: "Contact Us", href: "/contact" },
];